const program = [
    {
        time: "11h00",
        title: "Match de gala : Les amis de Camel vs Le Reste du Monde",
        description:
            "Un match convivial pour ouvrir la journée avec des invités, des amis de la ligue et des représentants de plusieurs communautés.",
    },
    {
        time: "14h00",
        title: "Demi-finale 1 : Thionville vs Camerlux",
        description:
            "Une rencontre décisive entre deux équipes ambitieuses qui veulent obtenir leur place pour la grande finale.",
    },
    {
        time: "16h00",
        title: "Demi-finale 2 : Cap-Vert vs Sénégal",
        description:
            "Un choc attendu entre deux formations solides, soutenues par leurs supporters et déterminées à rejoindre la finale.",
    },
];

export default function SemiFinalProgramSection() {
    return (
        <section className="rounded-2xl border border-white/10 bg-[#0d121b] p-6 md:p-8">
            <p className="text-sm font-black uppercase tracking-[0.22em] text-orange-300">
                Programme officiel
            </p>

            <h2 className="mt-3 text-2xl font-black uppercase text-white md:text-4xl">
                Demi-finales du samedi 6 juin 2026
            </h2>

            <p className="mt-4 max-w-4xl text-base leading-8 text-white/75">
                Les demi-finales auront lieu au stade situé au 158 Rue Neuwies,
                4635 Oberkorn Differdange. La journée débutera à 11h00 avec un
                match de gala, avant les deux demi-finales prévues à 14h00 et
                16h00.
            </p>

            <div className="mt-6 grid gap-4 md:grid-cols-3">
                {program.map((item) => (
                    <article
                        key={item.time}
                        className="rounded-xl border border-white/10 bg-white/5 p-5"
                    >
                        <p className="text-sm font-black uppercase text-orange-300">
                            {item.time}
                        </p>

                        <h3 className="mt-2 text-lg font-black text-white">
                            {item.title}
                        </h3>

                        <p className="mt-3 text-sm leading-7 text-white/65">
                            {item.description}
                        </p>
                    </article>
                ))}
            </div>
        </section>
    );
}